"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.context = void 0;
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
const context_1 = require("./api/context");
/**
 * Entrypoint for context API
 * @since 1.0.0
 */
exports.context = context_1.ContextAPI.getInstance();
//# sourceMappingURL=context-api.js.map